<template lang="html">
    <div class="client-settings__card">
        <h2 class="header-2">
            Parolă
        </h2>
        
        <FormUpdatePassword  
            @activeButton="activeNextStep = $event"
        />

        <UiButton 
            class="nexyo-button"
            :name="$store.state.settings.steps[0].isLoading ? 'Procesare..' : 'Actualizează'"
            @click="sendUpdatePassword"
            :disabled="!activeNextStep"
        />
    </div>
</template>

<script>

import UiButton from "@/components/ui/Button"
import FormUpdatePassword from '@/components/forms/Settings/Password'

import { mapActions } from 'vuex'

export default {
    components: {
        UiButton,
        FormUpdatePassword
    },
    data() {
        return {
            activeNextStep: false
        };
    },
    methods: {
        ...mapActions({
            updatePassword: 'settings/updatePassword'
        }),
        sendUpdatePassword() {
            if(this.activeNextStep) {
                this.$store.state.settings.steps[0].isLoading = true;
                this.updatePassword();
                this.$store.state.settings.currentStep = 0;
            }
        },
        loginOnEnter(event) {
            if (event.keyCode === 13) {
                this.sendLogin();
            }
        },
    }
}
</script>

<style lang="css" scoped>

</style>
